<footer class="main-footer d-print-none">
    <div class="float-right d-none d-sm-block">
      <b>Versión</b> 3.0.58
    </div>
    <span style="font-weight: 400;">Developed by Servidigital &copy; 2023</span>
  </footer>
